import { Controller } from "@hotwired/stimulus"

// Refresh only the pending review section so resolving the plan never replaces a
// half-written task note. The endpoint checks the current viewer on every poll.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.stopped = false
    this.schedule()
  }

  disconnect() {
    this.stopped = true
    clearTimeout(this.timer)
    this.request?.abort()
  }

  schedule() {
    if (!this.stopped) this.timer = setTimeout(() => this.refresh(), 2500)
  }

  async refresh() {
    this.request = new AbortController()
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" }, signal: this.request.signal
      })
      if ([401, 403, 404].includes(response.status)) return
      if (!response.ok) return this.schedule()
      const result = await response.json()
      if (this.stopped) return
      if (result.status === "pending") return this.schedule()

      const fieldset = this.element.closest("fieldset")
      fieldset?.querySelectorAll('input[name="task_action[review_plan_version]"]').forEach((input) => {
        input.value = result.plan_version || ""
      })
      fieldset?.querySelectorAll(".resolution-option").forEach((button) => {
        if (/^complete/.test(button.value || "")) button.disabled = Boolean(result.approval_blocked)
      })
      const template = document.createElement("template")
      template.innerHTML = result.html
      this.element.replaceWith(template.content)
    } catch (error) {
      if (error.name !== "AbortError") this.schedule()
    }
  }
}
